import React from 'react';
import { Box, Button, HStack } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';

import { nextKey } from '../../utils';
import { Ext } from './ext';

export const EE = ({ state, setter, onBlur }) => {
	const remove = e => {
		const { name } = e.target;
		const newState = { ...state };
		delete newState[name];
		setter(newState);
	};

	const add = () => {
		const next = nextKey(state);
		setter({
			...state,
			[next]: {
				education: { 0: {} },
				experience: { 0: {} },
				adresses: { 0: {} },
				trips: { 0: {} },
				relatives: { 0: {} },
			},
		});
	};

	return (
		<Box>
			{Object.keys(state).map(key => {
				const id = key;
				const item = state[key];
				const setItem = item => setter({ ...state, [key]: item });
				const ext = { id, remove, state: item, setter: setItem, onBlur };

				return <Ext key={key} {...ext} />;
			})}
			<HStack pt={4}>
				<Button
					leftIcon={<AddIcon />}
					colorScheme="blue"
					variant="solid"
					onClick={add}
				>
					Добавить форму Express Entry
				</Button>
			</HStack>
		</Box>
	);
};
